(function () {
  var MAKE_ORDER = ['Toyota', 'Lexus', 'Subaru', 'Acura', 'Honda', 'Infiniti', 'Nissan'];

  function escapeHtml(s) {
    var div = document.createElement('div');
    div.textContent = s == null ? '' : s;
    return div.innerHTML;
  }

  function formatMoney(amount) {
    var n = parseFloat(amount);
    if (isNaN(n)) return '';
    return '$' + n.toFixed(2).replace(/\.00$/, '');
  }

  function canonicalModel(make, raw) {
    var m = String(raw == null ? '' : raw).trim();
    if (make === 'Lexus') {
      if (m === 'GX' || m === 'GX 460') return 'GX';
      if (m === 'LX' || m === 'LX 570' || m === 'LX570') return 'LX';
    }
    return m;
  }

  function kitLabel(p) {
    if (p.kitTypeLabel) return p.kitTypeLabel;
    return p.kitType || 'Kit';
  }

  function kitTag(p) {
    var label = kitLabel(p).toLowerCase();
    if (label.indexOf('upgrade') !== -1) return 'Keeps Original Factory Screen';
    if (label.indexOf('conversion') !== -1) return 'Full Screen Replacement';
    return '';
  }

  function kitBadgeText(p) {
    var label = kitLabel(p);
    var tag = kitTag(p);
    if (tag) return label + ' | ' + tag;
    return label;
  }

  function kitSortKey(p) {
    var label = kitLabel(p).toLowerCase();
    if (label.indexOf('premium') !== -1) return 1;
    if (label.indexOf('conversion') !== -1) return 0;
    if (label.indexOf('upgrade') !== -1) return 2;
    return 3;
  }

  function sortMatches(matches) {
    var seen = {};
    return matches
      .filter(function (p) {
        if (!p.url || !p.handle) return false;
        if (seen[p.handle]) return false;
        seen[p.handle] = true;
        return true;
      })
      .slice()
      .sort(function (a, b) {
        var ka = kitSortKey(a);
        var kb = kitSortKey(b);
        if (ka !== kb) return ka - kb;
        return (parseFloat(a.price) || 0) - (parseFloat(b.price) || 0);
      });
  }

  function cardTitle(p) {
    if (p.displayName) return p.make + ' ' + p.displayName;
    return p.title || 'Hamilton kit';
  }

  /** Percent-encode path so handles with ®/™ don't 404. */
  function productHref(p) {
    var raw = p.url || (p.handle ? '/products/' + p.handle : '');
    if (!raw) return '#';
    try {
      if (raw.indexOf('://') !== -1) {
        var abs = new URL(raw, window.location.origin);
        abs.pathname = abs.pathname
          .split('/')
          .map(function (seg) {
            return encodeURIComponent(decodeURIComponent(seg));
          })
          .join('/');
        return abs.pathname + abs.search + abs.hash;
      }
      return raw
        .split('/')
        .map(function (seg, i) {
          if (i === 0 && seg === '') return '';
          return encodeURIComponent(decodeURIComponent(seg));
        })
        .join('/');
    } catch (e) {
      return raw;
    }
  }

  function fillSelect(sel, items, placeholder, disabled, selectedValue) {
    sel.innerHTML = '';
    var ph = document.createElement('option');
    ph.value = '';
    ph.textContent = placeholder;
    sel.appendChild(ph);
    items.forEach(function (item) {
      var opt = document.createElement('option');
      opt.value = item.value;
      opt.textContent = item.text;
      sel.appendChild(opt);
    });
    sel.disabled = !!disabled;
    if (selectedValue && Array.prototype.some.call(sel.options, function (o) { return o.value === selectedValue; })) {
      sel.value = selectedValue;
    } else {
      sel.value = '';
    }
  }

  function sortedMakes(products) {
    var seen = {};
    products.forEach(function (p) {
      seen[p.make] = true;
    });
    return Object.keys(seen).sort(function (a, b) {
      var ia = MAKE_ORDER.indexOf(a);
      var ib = MAKE_ORDER.indexOf(b);
      if (ia === -1) ia = 999;
      if (ib === -1) ib = 999;
      if (ia !== ib) return ia - ib;
      return a.localeCompare(b);
    });
  }

  function productModelKey(p) {
    return canonicalModel(p.make, p.model || p.displayName);
  }

  function initRoot(root) {
    var data = window.HMC_KIT_FINDER;
    if (!data || !data.products || !data.products.length) return;

    var products = data.products.filter(function (p) {
      return p.url && p.handle;
    });

    var panel = root.closest('.hmc-kit-finder__panel') || root;
    var makeSel = root.querySelector('[data-hmc-kit-finder-make]');
    var modelSel = root.querySelector('[data-hmc-kit-finder-model]');
    var yearSel = root.querySelector('[data-hmc-kit-finder-year]');
    var progressBar = panel.querySelector('[data-hmc-kit-finder-progressbar]');
    var resultsWrap = root.querySelector('[data-hmc-kit-finder-results]');
    var resultsLabel = root.querySelector('[data-hmc-kit-finder-results-label]');
    var grid = root.querySelector('[data-hmc-kit-finder-grid]');
    var emptyEl = root.querySelector('[data-hmc-kit-finder-empty]');

    if (!makeSel || !modelSel || !yearSel || !grid) return;

    function setProgress() {
      var make = makeSel.value;
      var model = modelSel.value;
      var year = yearSel.value;
      var progress = 0;
      var complete = false;

      if (make) progress = 0.33;
      if (make && model) progress = 0.66;
      if (make && model && year) progress = 1;
      if (!resultsWrap.hidden && make && model && year) complete = true;

      panel.style.setProperty('--hmc-finder-progress', String(progress));
      panel.classList.toggle('is-complete', complete);

      if (progressBar) {
        progressBar.setAttribute('aria-valuenow', String(Math.round(progress * 100)));
      }
    }

    function clearResults() {
      resultsWrap.hidden = true;
      emptyEl.hidden = true;
      resultsWrap.classList.remove('is-open');
      grid.classList.remove('is-fading');
      grid.innerHTML = '';
      panel.classList.remove('is-complete');
    }

    function setResultsContent(html, showEmpty) {
      if (showEmpty) {
        grid.innerHTML = '';
        emptyEl.hidden = false;
        resultsWrap.hidden = false;
        resultsWrap.classList.add('is-open');
        return;
      }

      emptyEl.hidden = true;
      resultsWrap.hidden = false;
      resultsWrap.classList.add('is-open');

      if (!grid.children.length) {
        grid.innerHTML = html;
        return;
      }

      grid.classList.add('is-fading');
      window.setTimeout(function () {
        grid.innerHTML = html;
        grid.classList.remove('is-fading');
      }, 180);
    }

    function productsForMake(make) {
      return products.filter(function (p) {
        return p.make === make;
      });
    }

    function uniqueModels(list) {
      var seen = {};
      list.forEach(function (p) {
        seen[productModelKey(p)] = true;
      });
      return Object.keys(seen).sort(function (a, b) {
        return a.localeCompare(b);
      });
    }

    function candidatesForMakeModel(make, model) {
      return products.filter(function (p) {
        return p.make === make && productModelKey(p) === model;
      });
    }

    function rangesForCandidates(cands) {
      // Cut the model’s kits into non-overlapping year choices. Adjacent
      // slices that offer the same kits are merged, so Tacoma is
      // 2005–2013, 2014–2015, and 2016–2019 instead of three overlapping ranges.
      var points = {};
      cands.forEach(function (p) {
        if (p.yearStart == null || p.yearEnd == null) return;
        points[p.yearStart] = true;
        points[p.yearEnd + 1] = true;
      });
      var years = Object.keys(points)
        .map(function (y) { return parseInt(y, 10); })
        .sort(function (a, b) { return a - b; });

      var slices = [];
      for (var i = 0; i < years.length - 1; i++) {
        var start = years[i];
        var end = years[i + 1] - 1;
        if (end < start) continue;
        var kits = cands.filter(function (p) {
          return p.yearStart <= start && p.yearEnd >= end;
        });
        if (!kits.length) continue;
        var key = kits
          .map(function (p) { return p.handle; })
          .sort()
          .join('|');
        var prev = slices[slices.length - 1];
        if (prev && prev.key === key && prev.e + 1 === start) {
          prev.e = end;
        } else {
          slices.push({ s: start, e: end, key: key });
        }
      }

      return slices.map(function (r) {
        return {
          value: String(r.s) + '-' + String(r.e),
          text: r.s === r.e ? String(r.s) : r.s + '\u2013' + r.e,
        };
      });
    }

    function matchesForRange(cands, rangeValue) {
      var parts = rangeValue.split('-');
      var selStart = parseInt(parts[0], 10);
      var selEnd = parseInt(parts[1], 10);
      // Year choices are fitment windows. A kit must cover the whole window,
      // so 2005–2015 Tacoma does not also appear under 2014–2019.
      return cands.filter(function (p) {
        return p.yearStart <= selStart && p.yearEnd >= selEnd;
      });
    }

    function renderCard(p) {
      var typeName = kitLabel(p);
      var desc = kitTag(p);
      var price = p.price ? formatMoney(p.price) : '';
      var title = cardTitle(p);
      var img = p.imageUrl
        ? '<img class="hmc-kit-finder__card-img" src="' +
          escapeHtml(p.imageUrl) +
          '" alt="" loading="lazy" decoding="async">'
        : '<div class="hmc-kit-finder__card-img hmc-kit-finder__card-img--placeholder" aria-hidden="true"></div>';

      return (
        '<article class="hmc-kit-finder__card">' +
        '<a class="hmc-kit-finder__card-link" href="' +
        escapeHtml(productHref(p)) +
        '">' +
        '<div class="hmc-kit-finder__card-media">' +
        img +
        '</div>' +
        '<div class="hmc-kit-finder__card-body">' +
        '<div class="hmc-kit-finder__card-tags">' +
        '<span class="hmc-kit-finder__card-type">' +
        escapeHtml(typeName) +
        '</span>' +
        (desc ? '<span class="hmc-kit-finder__card-desc">' + escapeHtml(desc) + '</span>' : '') +
        '</div>' +
        '<h3 class="hmc-kit-finder__card-title">' +
        escapeHtml(title) +
        '</h3>' +
        '<div class="hmc-kit-finder__card-foot">' +
        (price ? '<p class="hmc-kit-finder__card-price">' + escapeHtml(price) + '</p>' : '<span></span>') +
        '<span class="hmc-kit-finder__card-cta">View Kit</span>' +
        '</div>' +
        '</div>' +
        '</a>' +
        '</article>'
      );
    }

    function showMatches(matches, make, model, rangeValue) {
      setProgress();
      var visible = sortMatches(matches);
      var years = rangeValue ? rangeValue.replace('-', '\u2013') : '';
      resultsLabel.textContent = 'Kits for ' + make + ' ' + model + (years ? ' (' + years + ')' : '');

      if (!visible.length) {
        setResultsContent('', true);
        return;
      }

      setResultsContent(visible.map(renderCard).join(''), false);
      panel.classList.add('is-complete');
    }

    function onYearChange(cands) {
      var rangeValue = yearSel.value;
      if (!rangeValue) {
        clearResults();
        setProgress();
        return;
      }

      var matches = matchesForRange(cands, rangeValue);
      showMatches(matches, makeSel.value, modelSel.value, rangeValue);
    }

    function initMakes() {
      var makes = sortedMakes(products);
      fillSelect(
        makeSel,
        makes.map(function (m) {
          return { value: m, text: m };
        }),
        makes.length ? 'Select make' : 'Catalog unavailable',
        !makes.length
      );
      fillSelect(modelSel, [], 'Select model', true);
      fillSelect(yearSel, [], 'Select year range', true);
      modelSel._cands = [];
      clearResults();
      setProgress();
    }

    makeSel.addEventListener('change', function () {
      clearResults();
      var make = makeSel.value;
      if (!make) {
        fillSelect(modelSel, [], 'Select model', true);
        fillSelect(yearSel, [], 'Select year range', true);
        modelSel._cands = [];
        setProgress();
        return;
      }
      var models = uniqueModels(productsForMake(make));
      fillSelect(
        modelSel,
        models.map(function (m) {
          return { value: m, text: m };
        }),
        'Select model',
        false
      );
      fillSelect(yearSel, [], 'Select year range', true);
      modelSel._cands = [];
      setProgress();
    });

    modelSel.addEventListener('change', function () {
      clearResults();
      var make = makeSel.value;
      var model = modelSel.value;
      if (!make || !model) {
        fillSelect(yearSel, [], 'Select year range', true);
        modelSel._cands = [];
        setProgress();
        return;
      }
      var cands = candidatesForMakeModel(make, model);
      var ranges = rangesForCandidates(cands);
      fillSelect(yearSel, ranges, 'Select year range', !ranges.length);
      modelSel._cands = cands;
      setProgress();
    });

    yearSel.addEventListener('change', function () {
      var cands = modelSel._cands || [];
      onYearChange(cands);
    });

    root._hmcKitFinderReset = initMakes;
    initMakes();
  }

  function init() {
    document.querySelectorAll('[data-hmc-kit-finder]').forEach(initRoot);
  }

  function resetAllRoots() {
    document.querySelectorAll('[data-hmc-kit-finder]').forEach(function (root) {
      if (typeof root._hmcKitFinderReset === 'function') {
        root._hmcKitFinderReset();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      resetAllRoots();
    }
  });
})();
